import React from "react";
//#region types
import { GenericDocumentStatusTagsProps } from "models/propTypes/documentPropTypes";
//#endregion
//#region components
import { Tags } from "components/common";
import { useGenericDocumentService } from "serviceHooks";
//#endregion

const GenericDocumentStatusTags: React.FC<GenericDocumentStatusTagsProps> = (props) => {
  const genericDocumentService = useGenericDocumentService();
  return (
    <Tags
      tags={[genericDocumentService.getStateText(props.status)]}
      className={genericDocumentService.getStateLabelClass(props.status)}
    />
  );
};

export default GenericDocumentStatusTags;
